export default __webpack_public_path__ + "static/media/ris_logo_color_negative.c0b44294.svg";